interface ICallStatusProps {
  width?: number;
  height?: number;
}
const RedCrossIcon = (props: ICallStatusProps) => {
  const { width = 18, height = 18 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="#E92C2C" stroke="#E92C2C" />
      <mask
        id="mask0_1_2988"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="16"
        height="16"
      >
        <rect x="1.5" y="1.5" width="15" height="15" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1_2988)">
        <path
          d="M6.0465 12.75L5.25 11.9535L8.2035 9L5.25 6.0465L6.0465 5.25L9 8.2035L11.9535 5.25L12.75 6.0465L9.7965 9L12.75 11.9535L11.9535 12.75L9 9.7965L6.0465 12.75Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default RedCrossIcon;
